
@if (!chartReady()) {
  <div class="w-full relative">
  <div class="bg-white rounded rounded-xl h-[400px]">
    <chl-loader
      class="!absolute !top-1/2 !left-1/2 -translate-x-1/2 -translate-y-1/2"
    />
  </div>
</div>
} @else {
  <co-chart-card
  [chartHeader]="chartHeader()"
  [cssClass]="cssClass()"
  [filterOptions]="filterOptions()"
  [selectedFilters]="selectedFilters"
  (onFilterChange)="onDropdownChange()"
  [testResult]="testResult()"
 
>
  <!-- begin::Chart-->
  <div chart-content>
    @if(chartOptions && chartOptions.series?.length){
    <apx-chart
        [series]="chartOptions.series"
        [chart]="chartOptions.chart"
        [xaxis]="chartOptions.xaxis"
        [dataLabels]="chartOptions.dataLabels"
        [plotOptions]="chartOptions.plotOptions"
        [legend]="chartOptions.legend"
        [yaxis]="chartOptions.yaxis"
        [tooltip]="chartOptions.tooltip"
        [fill]="chartOptions.fill"
    ></apx-chart>
    }
     @else
    {
    <div class="flex items-center justify-center">
      <span class="text-black-500 text-lg font-medium">{{"REPORTS.NO_DATA_FOUND" | translate}}</span>
    </div>
    }
    <p-table 
      [value]="tableData()"
      [paginator]="true"
      [rows]="5"
      [tableStyle]="{ 'min-width': '50rem' }">
    <!-- Header -->
    <ng-template pTemplate="header">
      <tr>
        <th>{{"HEALTHCARE_PROVIDERS.GROUP" | translate}}</th>
        @for (key of categoryKeys(); track key) {
          <th>{{ key }}</th>
        }
        <th>{{"HEALTHCARE_PROVIDERS.TOTAL" | translate}}</th>
      </tr>
    </ng-template>

    <!-- Body -->
    <ng-template pTemplate="body" let-row>
      <tr>
        <td>{{ row.groupingKey }}</td>
        @for (key of categoryKeys(); track key) {
          <td>{{ row.categoryExpenses[key] ?? 0 }}</td>
        }
        <td>{{ row.total  }}</td>
      </tr>
    </ng-template>
  </p-table>
  </div>
</co-chart-card>}